export enum LeadTimeType{
  Hour = "H",
  Day = "D"
}
